<div class="busqueda-empresa_container">
    <h2>Empresas - Agentes vigilados</h2>

    <input
        type="text"
        class="form-control mb-3"
        placeholder="Buscar por NIT, Razón social, correo..."
        [(ngModel)]="searchTerm"
        (input)="filterCompanies()" />

    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>NIT</th>
                    <th>Razón social</th>
                    <th>Correo corporativo</th>
                    <th>Tipo de producto</th>
                    <th>Eslabon</th>
                    <th *appPermiso="'inactivar_empresa_admin_empresa'">Estado</th>
                    <th *appPermiso="'ver_empresa_admin_empresa'">Empresa</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="filteredCompanies?.length === 0">
                    <tr>
                        <td colspan="7" class="text-center">
                            No se encontraron agentes vigilados que coincidan con
                            la búsqueda
                        </td>
                    </tr>
                </ng-container>

                <ng-container *ngFor="let empresa of filteredCompanies">
                    <tr>
                        <td>{{ empresa.nit }}</td>
                        <td>{{ empresa.razonSocial }}</td>
                        <td>{{ empresa.correo_corporativo }}</td>
                        <td>
                            {{
                                etiquetaProductoTexto(
                                    empresa.tipo_producto_que_importa
                                )
                            }}
                        </td>
                        <td>{{ empresa.eslabon }}</td>
                        <td *appPermiso="'inactivar_empresa_admin_empresa'"> 
                            <button
                                type="button"
                                class="btn btn-sm"
                                [ngClass]="{
                                    'btn-success': empresa.estado === 'Activo',
                                    'btn-danger': empresa.estado !== 'Activo',
                                }"
                                (click)="
                                    actualizarEstado(empresa.id, empresa.estado)
                                "
                                [title]="
                                    empresa.estado === 'Activo'
                                        ? 'Desactivar agente'
                                        : 'Activar agente'
                                ">
                                {{
                                    empresa.estado === 'Activo'
                                        ? 'Activo'
                                        : 'Inactivo'
                                }}
                            </button>
                        </td>
                        <td class="conteiner_agente-vig" *appPermiso="'ver_empresa_admin_empresa'">
                            <button
                                type="button"
                                class="btn btn-warning btn-sm btn_user"
                                (click)="abrirModalVerEmpresa(empresa.id)"
                                title="Ver datos de la empresa">
                                Ver Empresa
                            </button>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
